import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import LevelBase from '../scenes/LevelBase';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Bubbles from './Bubbles';
import Spelly from './Spelly';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Sub extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {LevelBase} scene 
   */
  constructor(scene) {
    super(scene);

    this.scene = scene;

    this.lightTween = null;
    this.subTween = null;

    this.bubbles = null;

    this.subCont = null;
    this.sub = null;
    this.light = null;
    this.reflection = null;
    this.cockpitMask = null;
    this.hint = null;
    this.skip = null;
    this.repeat = null;
    this.engine = null;
    this.hook = null;

    this.bubbleCont = null;
    this.shader = null;
    this.speech = null;
    this.speechTxt = null;

    /** @type {Phaser.GameObjects.Image[]} */
    this.buttons = [];

    this.setup();
  }

  setup () {
    this.createSub();
    this.createSpelly();
    this.createBubbles();
  }

  createSub () {
    this.subCont = this.scene.add.container();

    this.sub = ABCyaPhaser.Images.addImage(0, 55, UIAssetKeys._smallSub, this.subCont);

    this.light = ABCyaPhaser.Images.addImage(this.sub.width / 2 - 120, this.sub.height / 2 + 20, UIAssetKeys._3_Level_Assets_Common_Sub_Sm_Lt, this.subCont).setOrigin(0, 0.4);

    this.hint = ABCyaPhaser.Images.addImage(-120, this.sub.height / 2 - 80, UIAssetKeys._3_Level_Assets_Common_Sub_Sm_HintBtn, this.subCont);
    this.buttons.push(this.hint);

    this.skip = ABCyaPhaser.Images.addImage(this.hint.x + 100, this.sub.height / 2 - 80, UIAssetKeys._3_Level_Assets_Common_Sub_Sm_SkipBtn, this.subCont);
    this.buttons.push(this.skip);

    this.repeat = ABCyaPhaser.Images.addImage(this.skip.x + 100, this.sub.height / 2 - 80, UIAssetKeys._3_Level_Assets_Common_Sub_Sm_RepeatBtn, this.subCont);
    this.buttons.push(this.repeat);

    this.engine = ABCyaPhaser.Images.addImage(this.skip.x + 118, this.sub.height / 2, UIAssetKeys._engine, this.subCont);

    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].setInteractive({ useHandCursor: true }).disableInteractive();
    }

    this.subCont.setPosition(this.scene.scale.width / 2 - 50, -this.sub.height / 2 - 100);

    this.descend();
  }

  descend () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._submarine_enter, this.scene);

    this.subTween = ABCyaPhaser.Tweens.addTween(this.subCont, 3000, { y: 130 }, Phaser.Math.Easing.Sine.Out, () => {
      this.idleSub();
    });
  }

  idleSub () {
    this.moveLight();

    this.subTween = ABCyaPhaser.Tweens.addTween(this.subCont, 4000, { y: 150, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
  }

  moveLight () {
    const randDel = Phaser.Math.Between(3000, 6000);
    const randTime = Phaser.Math.Between(1250, 2250);
    const randAng = Phaser.Math.Between(20, 70);

    this.spelly.moveLight(randTime, randDel);
    this.lightTween = ABCyaPhaser.Tweens.addTween(this.light, randTime, { angle: randAng, delay: randDel, yoyo: true, hold: randDel }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.moveLight();
    });
  }

  createSpelly () {
    this.spelly = new Spelly(this.scene, 'cockpit');
    this.subCont.add(this.spelly);
    this.spelly.setPosition(225, 185);
    this.spelly.setScale(.7, .7);

    this.cockpitMask = this.scene.add.graphics({ fillStyle: { color: 0xff3300, alpha: 0 } });
    this.cockpitMask.fillRect(171, 16, 150, 130);

    this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, this._fixMaskPosition, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.events.off(Phaser.Scenes.Events.POST_UPDATE, this._fixMaskPosition, this);
    });

    this.spelly.mask = this.cockpitMask.createGeometryMask();

    this.reflection = ABCyaPhaser.Images.addImage(170, 22, UIAssetKeys._3_Level_Assets_Common_Sub_Sm_WindowFrgd, this.subCont).setOrigin(0);
  }

  _fixMaskPosition() {
    const subContWorldPos = ABCyaPhaser.GameObjects.getScreenPosition(this.subCont);
    this.cockpitMask.setPosition(subContWorldPos.x, subContWorldPos.y);
  }

  createBubbles () {
    this.bubblesManager = this.scene.add.particles(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._3_Level_Assets_Common_Bbl);
    this.bubblesManager.setPosition(50,180);
    this.bubbles = this.bubblesManager.createEmitter({
      speedX: { min: -50, max: 0 },
      speedY: { min: -50, max: 50 },
      alpha: { min: 0.1, max: 0.7 },
      scale: { start: 0.1, end: 1, ease: Phaser.Math.Easing.Quadratic.Out },
      gravityY: -200,
      lifespan: 2000,
      frequency: 400,
      quantity: 5
    });
    this.subCont.add(this.bubblesManager);
    this.bubbles.start();
  }

  enableButtons () {
    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].setInteractive({ useHandCursor: true });
      this.buttons[i].removeListener(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      this.buttons[i].on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleClick(this.buttons[i]));
    }
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} obj 
   */
  handleClick (obj) {
    if (obj.frame.name === UIAssetKeys._3_Level_Assets_Common_Sub_Sm_RepeatBtn) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
      ABCyaPhaser.Audio.playOneShot(this.scene.words.chosenWord, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }
    else if (obj.frame.name === UIAssetKeys._3_Level_Assets_Common_Sub_Sm_SkipBtn) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
      this.disableButtons();

      this.scene.words.newWord();
    }
    else if (obj.frame.name === UIAssetKeys._3_Level_Assets_Common_Sub_Sm_HintBtn) {
      this.scene.words.showHint();
    }
  }

  disableButtons () {
    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].disableInteractive();
    }
  }

  createSpeech () {
    this.bubbleCont = this.scene.add.container();
    this.subCont.add(this.bubbleCont);

    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._Octopus, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.speech = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._1_Welcome_and_Level_Screen_WordBbl_LvlScrn, this.bubbleCont).setOrigin(0.6, 1)
      .setScale(1.4,1);

    const txt =
			'Our friend the\n' +
			'octopus LOVES vowels!\n' +
			'Select the vowels\n' +
			'for her to eat.';
    this.speechTxt = ABCyaPhaser.Text.addText(-33,-125, 20, 0x21409a, FontKeys._rolling_no_oneregular, txt, this.bubbleCont, true).setOrigin(0.5);
    this.speechTxt.setLineSpacing(1);
    this.bubbleCont.setScale(0, 0);
    this.bubbleCont.setPosition(280, 80);

    ABCyaPhaser.Tweens.addTween(this.bubbleCont, 500, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
  }

  tweenOutSpeech () {
    ABCyaPhaser.Tweens.addTween(this.bubbleCont, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In, () => this.destroySpeech());
  }

  destroySpeech () {
    this.speechTxt.destroy();
    this.speech.destroy();
    this.bubbleCont.destroy();
  }

  ascend () {
    this.subTween = ABCyaPhaser.Tweens.addTween(this.subCont, 2000, { y: -this.sub.height / 2 - 100 }, Phaser.Math.Easing.Sine.In, () => {
      this.cleanUp();
    });
  }

  grabTreasure () {
    this.hook = ABCyaPhaser.Images.addImage(50, -50, UIAssetKeys._Hook, this.scene).setOrigin(0.5, 0);
    this.subCont.addAt(this.hook, 0);

    this.subTween = ABCyaPhaser.Tweens.addTween(this.hook, 2000, { y: 150 }, Phaser.Math.Easing.Quadratic.InOut, () => {
      this.escape();
    });
  }

  escape () {
    this.ascend();
    this.subTween = ABCyaPhaser.Tweens.addTween(this.hook, 2000, { y: -50 }, Phaser.Math.Easing.Quadratic.Out);

    this.scene.words.transition.releaseTreasure();

    new Bubbles(this.scene);
  }

  cleanUp () {
    console.log('cleaning up sub');
    if (this.bubblesManager) this.bubblesManager.destroy();

    this.spelly.cleanUp();

    this.scene.tweens.killTweensOf(this.subCont);
    this.subTween?.stop();
    this.lightTween?.stop();

    this.subCont.destroy();
  }
}